"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  carbonCalculator: {
    title: 'Carbon Calculator',
    line: 'LANE',
    volume: 'VOLUME',
    unit: 'UNIT',
    tips_1: 'DISCLAIMER:',
    tips_2: 'SITC is committed to reduce CO2 emissions. To help our customers achieve the lowest possible carbon footprint,below we have developed co2  calculator ,with which you can now easily manage your carbon emissions  for the shipment  any time.',
    tips_3: 'The calculator runs based on actual dynamic data of SITC operated vessels.  The calculated emissions may deflect from actual emissions subject to actual sailing conditions, operation condition, etc., and SITC does not take any legal responsibility whatsoever for the calculated results being applied. The calculations should be used at your own discretion. If you have found any irregularities or in doubt of the calculations, please kindly contact us.',
    result: 'Result',
    distance: 'DISTANCE(KM)',
    carbonNum: 'CARBON EMMISION(KG)',
    serviceLineIdIsNull: 'LANE is null',
    volumeIsNull: 'VOLUME is null',
    unitIsNull: 'UNIT is null'
  },
  button: {
    search: 'Search',
    reset: 'Reset'
  }
};